import i18n from "../i18n";
import { cn } from "../lib/utils";
import { TicketPriority } from "../types/ticket.types";

const TicketPriorityBadge = ({ priority }: { priority: TicketPriority }) => {
	const ticketPriorityBackgroundColors = new Map<TicketPriority, string>([
		[TicketPriority.LOW, "bg-green-50"],
		[TicketPriority.MEDIUM, "bg-orange-50"],
		[TicketPriority.HIGH, "bg-red-50"],
	]);
	const ticketPriorityColors = new Map<TicketPriority, string>([
		[TicketPriority.LOW, "text-green-700"],
		[TicketPriority.MEDIUM, "text-orange-700"],
		[TicketPriority.HIGH, "text-red-700"],
	]);
	const ticketPriorityBorderColors = new Map<TicketPriority, string>([
		[TicketPriority.LOW, "border-green-300!"],
		[TicketPriority.MEDIUM, "border-orange-300!"],
		[TicketPriority.HIGH, "border-red-300!"],
	]);

	return (
		<div
			className={cn(
				"w-fit",
				"text-xs font-medium text-center",
				"px-2 py-0.5",
				"border! rounded-xl",
				"capitalize",
				ticketPriorityBackgroundColors.get(priority ?? TicketPriority.LOW),
				ticketPriorityColors.get(priority ?? TicketPriority.LOW),
				ticketPriorityBorderColors.get(priority ?? TicketPriority.LOW),
			)}
		>
			{i18n.t(`ticket.priority.${priority}`)}
		</div>
	);
};

export default TicketPriorityBadge;
